<script>
import { Doughnut, mixins } from 'vue-chartjs';

export default {
  extends: Doughnut,
  mixins: [mixins.reactiveProp],
  props: {
    options: { type: Object, default: () => ({}) }
  },
  computed: {
    chartOptions() {
      return {
        circumference: Math.PI,
        rotation: Math.PI,
        ...this.options
      };
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.chartOptions);
  }
};

</script>
